import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

const auditQueryMutations: UpdatesConfig['Mutation'] = {
  auditQueryCreate: (data: Data, __: Variables, cache: Cache) => {
    invalidateQuery('auditQueries', cache);
  },
};

export default auditQueryMutations;
